import React from 'react';
import './GetStartedCta.css';

export default function GetStartedCta() {
  return (
    <section className="cta-wrapper">
      <div className="cta-card">
        {/* Decorative landscape */}
        <div className="cta-illustration" aria-hidden />

        {/* Content */}
        <div className="cta-content">
          <h2 className="cta-title">Ready to get started?</h2>
          <p className="cta-subtitle">
            Get up and running right now.
          </p>

          <button className="cta-button">
            Get started
          </button>
        </div>
      </div>
    </section>
  );
}
